import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export { default as Attachment } from './Attachment';
export type { AttachmentProps } from './Attachment';

export interface AttachmentsListProps extends PropsWithChildren {
  className?: string;
}

export default function AttachmentsList({
  className,
  ...props
}: AttachmentsListProps) {
  return <div className={twMerge(classes.list, className)} {...props} />;
}
